<textarea id="report-summary-text-input"
          (ngModelChange)="updateSummaryText($event)"
          [(ngModel)]="summaryText"
          rows="7" placeholder="Type interpretation summary here"
          class="interpretation-summary-text" maxlength="30000">
</textarea>
<span ng-if="summaryText.length == 30000" class="summary-error-message">The maximum allowed characters for interpretation summary is 30000</span>

